<div class="select-items-dialog">
  <button mat-icon-button [mat-dialog-close]="false" style="background-color: transparent;"><mat-icon>close</mat-icon></button>
  <span class="select-items-description"><span>{{(data.items$ | async ).length}}</span> {{data.descriptionTitle}}</span>
  <span>
    @for ( button of data.buttons; track button.display) {
      @if (button.triggerAnalytics) {
        <button mat-button (click)="onButtonClick(button); triggerAnalytics(button.triggerAnalytics.triggerName, button.triggerAnalytics.eventCategory);">{{button.display}}</button>
      } @else {
        <button mat-button (click)="onButtonClick(button)">{{button.display}}</button>
      }
    }
  </span>
</div>
